import tw, { styled, theme } from 'twin.macro'
import LayoutContent from '@components/LayoutContent'

const SearchStyle = {
  Layout: styled(LayoutContent)`
    ${tw`bg-white`}
    padding-bottom: 44px;
    @media (min-width: ${theme`screens.md`}) {
      padding-bottom: 111px;
    }
  `,
  Container: styled.div`
    position: relative;
    width: 100%;
    /* 100vh - 開啟 app 提示高度 - header 高度 */
    min-height: calc(100vh - 62px - 64px);
    padding: 0 16px;
    margin: 0 auto;
    @media (min-width: ${theme`screens.md`}) {
      position: relative;
      width: 768px;
      /* 100vh - 廣告高度 + header 高度 */
      min-height: calc(100vh - 260px + 80px);
      margin: 0 auto;
      padding: 0;
    }
  `,
  InputArea: styled.div`
    position: relative;
    width: 100%;
    height: 64px;
    margin-top: 20px;
    border-radius: 8px;
  `,
  Section: styled.section`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    margin-top: 20px;
    @media (min-width: ${theme`screens.md`}) {
      margin-top: 40px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    > .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      ${tw`text-black font-medium`}
      margin-bottom: 24px;

      > svg {
        margin-right: 4px;
      }
    }

    > .content {
      button {
        ${tw`mr-2 mb-4 cursor-pointer`}
      }
    }
  `,
  Title: styled.p`
    font-size: 16px;
  `,
  ClearBtn: styled.p`
    font-size: 12px;
    line-height: 16px;
    margin-left: 12px;
    cursor: pointer;
    ${tw`text-gray-400`}
  `,
  CardWrapper: styled.div`
    width: 100%;
    box-sizing: border-box;
    @media (min-width: ${theme`screens.md`}) {
      width: 368px;
    }
  `,
  H1: styled.h1`
    font-size: 20px;
    line-height: 31px;
    letter-spacing: 0.5px;

    .keyword {
      font-weight: 600;
      margin-right: 10.5px;
    }

    margin-top: 12px;
    @media (min-width: ${theme`screens.md`}) {
      margin-top: 20px;
    }
  `,
  ResultContainer: styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 12px;
    @media (min-width: ${theme`screens.md`}) {
      margin-top: 20px;
    }
  `,
  EmptyResultContainer: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 68px 0;
    font-size: 16px;

    ${tw`text-black`}
    > svg {
      margin-bottom: 0;
      width: 200px;
    }

    @media (min-width: ${theme`screens.md`}) {
      padding: 75px 0;
      > svg {
        margin-bottom: 42px;
        width: auto;
      }
    }
  `,
  LoaderBox: styled.div`
    width: 100%;
    @media (min-width: ${theme`screens.md`}) {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  `,
  Footer: styled.section`
    margin-top: 0;
    @media (min-width: ${theme`screens.md`}) {
      margin-top: 13px;
    }
  `,
  DropdownBar: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 12px auto 24px;
  `,
  DropdownAction: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    position: relative;

    > svg {
      margin-left: 4px;
    }

    &:first-child {
      padding-right: 24px;
    }
  `,
  PopBox: styled.div`
    position: absolute;
    top: 32px;
    left: 0;
    z-index: 1;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  `,

  PopItem: styled.div`
    width: 144px;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 500;
    color: #333333;

    :hover {
      background-color: rgba(102, 102, 255, 0.08);
      border-radius: 4px;
    }

    &.active {
      color: #6666ff;
    }
  `,
}
export default SearchStyle
